import {NewsError} from './NewsError.js'

export class GetNewsDetailError extends NewsError {}
